import { AuthFacade } from '@facades/auth/authFacade';
import { AccountService } from '@services/account/account.service';
import { Injectable } from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateChild, Router} from '@angular/router';
import { Observable } from 'rxjs';
import {MessagePageComponent} from '@pages/layout/messages/message-page/message-page.component';
import {School} from '@models/shool';

@Injectable()
export class PageGuardGuard implements CanActivate, CanActivateChild {
  school: School = JSON.parse(localStorage.getItem('school'));
  constructor(
    private accountService: AccountService,
    private router: Router
  ) {}

  private getAuthenticatedUserOrRedirect() {
    const user = AuthFacade.getUser();
    if (!AuthFacade.getAuthStatus() || !AuthFacade.getToken() || !user) {
      this.router.navigate(['/auth/login']);
      return null;
    }
    return user;
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    console.log('checking route access');
    return !!this.getAuthenticatedUserOrRedirect();
  }
  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const user = this.getAuthenticatedUserOrRedirect();
    if (!user) {
      return false;
    }
    const currentUrl = state.url.split('?')[0].replace(/\/$/, '');
    const adminOnlyPaths = ['/teachers', '/students'];
    if (adminOnlyPaths.includes(currentUrl) && user.role !== 'admin') {
      this.router.navigate(['/dashboard']);
      return false;
    }
    const superAdminOnlyPathPrefixes = [
      '/subscriptions/scenario',
      '/subscriptions/add',
      '/subscriptions/edit',
      '/admins',
      '/school',
      '/platform-billing-preview',
      '/project-management',
      '/platform-stripe-accounts',
      '/reports/super-reports',
      '/reports/super-payroll',
      '/reports/super-profit',
    ];
    if (superAdminOnlyPathPrefixes.some(path => currentUrl.startsWith(path)) && user.role !== 'super_admin') {
      this.router.navigate(['/dashboard']);
      return false;
    }
    if (MessagePageComponent.instance) {
      return MessagePageComponent.instance.stopEditOrCreate('redirectTo', state.url);
    }
    const status = this.accountService.findSubscriptionStatusForSchool(user.systemSubscriptionStatus, user.activeSchool);
    if (status && status.status !== 'active') {
      if (['dashboard', 'program', 'curriculums', 'messages'].indexOf(next.routeConfig.path) !== -1) {
        return false;
      } else {
        return true;
      }
    } else if (status && status.status === 'active'
      && status.isTrial === true
      && ['subscriptions'].indexOf(next.routeConfig.path) !== -1
      && user.yearAttendanceFromApi.length === 0
      && this.school.is_try_before_buy === 1) {
      return false;
    } else {
      return true;
    }
    return true;
  }
}
